import React from "react";
import { useParams } from "react-router-dom";
import { useHomeNavigation } from "../../hooks/useHomeNavigation";
import { productsContent } from "../Home/products.data";
import { PageTitle } from "../../PageTitle";
import {
  BackLink,
  PlaceholderCard,
  PlaceholderPage,
} from "./ProductPlaceholder.styles";

const ProductPlaceholder: React.FC = () => {
  const { slug } = useParams();
  const product = productsContent.groups
    .flatMap((group) => group.products)
    .find((item) => item.slug === slug);

  const navigateToHome = useHomeNavigation();

  return (
    <>
      <PageTitle
        title={
          `${product?.title} — Интеллект-Развитие-Технологии` ??
          "Интеллект-Развитие-Технологии"
        }
      />
      <PlaceholderPage>
        <PlaceholderCard>
          <h1>{product?.title ?? "Продукт"}</h1>
          <p>Страница находится в разработке.</p>
          <BackLink onClick={() => navigateToHome("products")}>
            Вернуться к продуктам
            <i className="pi pi-arrow-left" />
          </BackLink>
        </PlaceholderCard>
      </PlaceholderPage>
    </>
  );
};

export default ProductPlaceholder;
